import React from 'react';
import './AboutUs.css';
import ConsultationSection from '../components/ConsultationSection';

const AboutUs = () => {
  return (
    <div className="about-page" id="about-us">
      {/* Premium Hero Section */}
      <section
        className="about-hero"
        style={{
          backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/home-banner.jpg')`
        }}
      >
        <div className="about-hero__content">
          <h1 className="about-hero__title">About us</h1>
          <nav className="about-hero__breadcrumb" aria-label="breadcrumb">
            <a href="/" className="about-hero__breadcrumb-link">
              Home
            </a>
            <span className="about-hero__breadcrumb-separator">&gt;</span>
            <span className="about-hero__breadcrumb-current">About us</span>
          </nav>
        </div>
      </section>

      {/* Things We Are Doing Section */}
      <section className="about-doing">
        <div className="about-doing__container">
          {/* Left Column: Text Content */}
          <div className="about-doing__text-col">
            <h2 className="about-doing__title">THINGS WE ARE DOING</h2>
            <div className="about-doing__content">
              <p className="about-doing__paragraph">
                Living in the US in 2020, a Muslim family lived excessively far from the Mosque to take their children for a week after week <a href='/' className="about-doing__highlight">Quran coaching</a>. Picking and dropping full circle would be an almost two-hour venture. Hafiz-Quran Chief settled this issue by opening an online chance as indicated by the cutting-edge period. With their expert involvement with innovation, they had the option to build up an online Quran Foundation: <a href='/' className="about-doing__highlight">AlQuranLesson.com</a>. Interestingly, Quran coaching is to be done live and online from the solace of their own home, making the most common way of keeping your family put resources into Islam adaptable. Since 2005, Quran Perusing has instructed more than 100000 live meetings and spread Islamic Training to more than 30 million through their versatile applications.
              </p>
              <p className="about-doing__paragraph">
                The accomplished mentors at AlQuranLesson.com share the vision of their Chief in accepting that the reliability of offering Quran Schooling ought to be performing with the most extreme devotion. The accomplished personnel and the first vision behind AlQuranLesson.com have settled on it the best option for guardians needing to show their kids Islam and The Quran.
              </p>
            </div>
          </div>

          {/* Right Column: Image */}
          <div className="about-doing__image-col">
            <div className="about-doing__image-wrapper">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/about1.jpg`}
                alt="Learn Quran With Tajweed Online - Al Quran Lesson"
                className="about-doing__img"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Double Column Info Section */}
      <section className="about-info">
        <div className="about-info__container">
          {/* Left Column: About Us In Short */}
          <div className="about-info__col">
            <h3 className="about-info__title">ABOUT US IN SHORT</h3>
            <p className="about-info__paragraph">
              We are at a present showing over 500 understudies in a few nations including the USA, Canada, Australia, Dubai and the UK. Our understudies range from age 4 to 65 years. Additionally, our guides have:
            </p>
            <ul className="about-info__list">
              <li className="about-info__list-item">Eight years of Islamic Degree.</li>
              <li className="about-info__list-item">Retention of Whole Quran.</li>
              <li className="about-info__list-item">Inside and out preparing in Tajweed.</li>
              <li className="about-info__list-item">Quite a long while of Quran educating experience.</li>
              <li className="about-info__list-item">Proficient preparing from us on the best way to more readily rouse kids for learning.</li>
            </ul>
          </div>

          {/* Right Column: About Our Quran Tutors */}
          <div className="about-info__col">
            <h3 className="about-info__title">ABOUT OUR QURAN TUTORS</h3>
            <p className="about-info__paragraph">
              Some significant characteristics of Our Guides:
            </p>
            <ul className="about-info__list">
              <li className="about-info__list-item">Hafiz-e-Quran.</li>
              <li className="about-info__list-item">Very much aware of the principles of recitation.</li>
              <li className="about-info__list-item">Have top to bottom information on Tajweed and Tarteel.</li>
              <li className="about-info__list-item">Have fantastic order on Arabic, English and Urdu dialects.</li>
              <li className="about-info__list-item">Profoundly energetic and comprehend the intricacies looked at in this calling.</li>
              <li className="about-info__list-item">Trust in understudy focused educating.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Achievements Section */}
      <section className="about-achievements">
        <div className="about-achievements__container">
          {/* Left Column: Trophy Image */}
          <div className="about-achievements__image-col">
            <div className="about-achievements__image-wrapper">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/acheivement.png`}
                alt="Our Achievements Trophy"
                className="about-achievements__img"
              />
            </div>
          </div>

          {/* Right Column: Text Content */}
          <div className="about-achievements__text-col">
            <h3 className="about-achievements__title">OUR ACHIEVEMENTS</h3>
            <div className="about-achievements__content">
              <p className="about-achievements__paragraph">
                We at <strong className="about-achievements__bold">Al Quran Lesson</strong> being the specialist organization; allowing individuals to have the chance to peruse and learn Qur'an over the web with straightforward and simple techniques. It is effectively working since 2009 and has acquired huge notoriety among the majority, particularly those dwelling in non-Muslim states. Its enrollment has now reached up to 5600; comprising of both youthful and old and is consistently expanding as time passes.
              </p>
              <p className="about-achievements__paragraph">
                We offer one of a kind from some other instructive program on the web. Our master mentors not just dominate with showing Quran Recitation to the Understudies yet, in addition, furnish Understudies with the information on what specific Sections mean, along these lines expanding their Islamic arrangement and making the exercises as intelligent as possible.
              </p>
              <p className="about-achievements__paragraph">
                Al Quran Exercise was a little arrangement imagined by a Muslim dwelling abroad and confronting trouble to show his kids Quran recitation. Right away, his little vision, as AlQuranLesson.com, lead to a marvelous open door for that load of Muslims dealing with precisely the same issue. <strong className="about-achievements__bold">Al Quran Lesson</strong> presently invest heavily in being the pioneers of a particularly honorable program drawing Muslims towards the lessons of the Sacred Quran.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Working Standards Section */}
      <section className="about-working">
        <div className="about-working__container">
          {/* Left Column: Text Content */}
          <div className="about-working__text-col">
            <h4 className="about-working__title">WORKING STANDARDS</h4>
            <div className="about-working__content">
              <p className="about-working__paragraph">
                Quran implies presentation or recitation. We give a chance to learning the Quran and to recount the blessed stanzas with the right elocution and <a href='/online-tajweed-classes-tajweed-course/' className="about-working__highlight">Tajweed</a>. We don't think twice about quality exercises and instructing. To ensure this fruitful working norm, we have chosen the best Quran mentors to furnish you with their devoted administrations.
              </p>
            </div>
          </div>

          {/* Right Column: Certificate Image */}
          <div className="about-working__image-col">
            <div className="about-working__image-wrapper">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/working.webp`}
                alt="Working Standards Certificate"
                className="about-working__img"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Our Approach Section */}
      <section className="about-approach">
        <div className="about-approach__container">
          {/* Left Column: Approach Image */}
          <div className="about-approach__image-col">
            <div className="about-approach__image-wrapper">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/approach.webp`}
                alt="Our Approach Icon"
                className="about-approach__img"
              />
            </div>
          </div>

          {/* Right Column: Text Content */}
          <div className="about-approach__text-col">
            <h2 className="about-approach__title">OUR APPROACH</h2>
            <div className="about-approach__content">
              <p className="about-approach__paragraph">
                Our methodology is engaged and dynamic. We utilize various strategies to give a powerful, quick and dependable Quran understanding system. Our program approach centres around the accompanying:
              </p>
              <ul className="about-approach__list">
                <li className="about-approach__list-item">
                  Understudies learn at various paces; a few understudies need a lot more prominent help and additionally time in doing jobs. Subsequently, our committed mentors oblige their showing styles as per the understudies learning.
                </li>
                <li className="about-approach__list-item">
                  Our very much prepared coaches utilize various Cooperations to coordinate with various Purposes and Results.
                </li>
                <li className="about-approach__list-item">
                  We utilize to set up however differing schedules to make the Islamic showing fascinating yet educated.
                </li>
                <li className="about-approach__list-item">
                  Compelling education includes viable association and the board. Our on-location board staff is capable to completely care for this viewpoint.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Parallax Who We Are Section */}
      <section
        className="about-who"
        style={{
          backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/About.avif')`
        }}
      >
        <div className="about-who__container">
          <h5 className="about-who__title">WHO WE ARE?</h5>
          <div className="about-who__content">
            <p className="about-who__paragraph">
              We are an enlisted school in the territory of Ontario, Canada and the first to present the Online Quran Understanding Project. Our master guides have broad training and involvement with showing Quran on the web. We have planned a better system in educating by which we persuade little youngsters and make it fascinating for them to learn Quran at home.
            </p>
            <p className="about-who__paragraph">
              With the assistance of A-list programming, understudies can see Arabic scripts and read live with their educator. We are utilizing legitimacy Programming which empowers prompt connection and input among understudy and teachers. Excellent programming considers a vis-à-vis experience.
            </p>
          </div>
        </div>
      </section>

      {/* Customized Consultation Section */}
      <ConsultationSection
        title="FREE CONSULTATION CALL - Ask From Experts"
        subtitle={
          <div className="consultation-section__custom-subtitle">
            <p>— Get answers to your questions — Enquire about our Holy Quran teaching services</p>
            <p>— Recommendations & suggestions from experts</p>
          </div>
        }
      />
    </div>
  );
};

export default AboutUs;

